import { Container } from './styles'
// 1. Pastikan Anda sudah menambahkan foto Anda ke src/assets/
//    dengan nama 'SergioPhoto.webp' (atau ubah nama file di bawah ini)
import MyPhoto from '../../assets/SergioPhoto.webp' 
import python from '../../assets/python.svg'
// 
// PERBAIKAN DI SINI: Path-nya sudah dibetulkan
// 
import javaV from '../../assets/java.svg' // Mengganti nama 'java' menjadi 'javaV' untuk menghindari konflik
import wordpress from '../../assets/wordpress.svg'
import shopify from '../../assets/shopify.svg'
import htmlIcon from '../../assets/html-icon.svg'
import cssIcon from '../../assets/css-icon.svg'
import jsIcon from '../../assets/js-icon.svg'
// import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from '../../assets/react-icon.svg'
import typescriptIcon from '../../assets/typescript-icon.svg'
import vueIcon from '../../assets/vue-icon.svg'
import boostrapIcon from '../../assets/bootstrap-icon.svg'
import ScrollAnimation from 'react-animate-on-scroll'

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        
        {/* PARAGRAF BARU DARI CV ANDA */}
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hi there! I'm an Informatics student from Al-Azhar Indonesia University
            with a diverse technical skillset in Data Science, Networking, and
            IoT.
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        >
          <p>
            I have hands-on experience in AI/ML model training (using Python
            and the Hugging Face ecosystem), IoT development (Arduino, ESP32,
            MQTT), and network routing and switching.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            Complemented by active organizational experience, I am eager to
            contribute to and learn from a challenging technology internship.
          </p>
        </ScrollAnimation>
        
        {/* PENDIDIKAN BARU DARI INFO ANDA */}
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education">
            <h3>Education:</h3>
            <h4>Bachelor of Informatics (S1)</h4>
            <p>University of Al-Azhar Indonesia | 2022 - Present</p>
            <p>GPA: 3.62</p>
          </div>
        </ScrollAnimation>
        
        {/* PENGALAMAN ORGANISASI (SUDAH DIRAPIHKAN) */}
        <ScrollAnimation animateIn="fadeInLeft" delay={550}>
          <div className="experience">
            <h3>Organizational Experience:</h3>
            
            {/* Item 1 */}
            <h4>Head of Creative Economy</h4>
            <p>Himpunan Informatika (HMIF) | 2024 - 2025</p>
            
            {/* Item 2 (Dengan spasi di atasnya) */}
            <h4 style={{ marginTop: '1.5rem' }}>Member of Academic</h4>
            <p>Himpunan Informatika (HMIF) | 2023 - 2024</p>
            
            {/* Item 3 (Dengan spasi di atasnya) */}
            <h4 style={{ marginTop: '1.5rem' }}>Online Seller Management</h4>
            <p>JIPD MALL Online Shop | 2020 - Present</p>

          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        
        {/* ANDA BISA MENYESUAIKAN IKON SKILL INI NANTI */}
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={python} alt="python" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.11 * 1000}>
              <img src={javaV} alt="java" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          {/* <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={vueIcon} alt="Vue" />
            </ScrollAnimation>
          </div> */}
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={wordpress} alt="Wordpress" />
            </ScrollAnimation>
          </div>
          {/* <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={shopify} alt="shopify" />
            </ScrollAnimation>
          </div> */}
          <div className="hability">
            <ScrollAnimation animateIn="FadeInUp" delay={0.18 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.21 * 1000}>
          {/* 2. Pastikan nama file foto Anda sudah benar */}
          <img src={MyPhoto} alt="Muhammad Abiyasha Sergio" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}